export const invoicePdfTranslations = {
  he: {
    invoiceScan: {
      chooseHint: 'אפשר להוסיף תמונות וקובצי PDF. כשמזוהות כמה חשבוניות באותו PDF, הן מוצגות בנפרד לבדיקה לפני השמירה.',
      pdfPageRange: 'עמודים {{from}}–{{to}} מתוך הקובץ ({{count}} עמודים)',
      pdfSplitNotice: 'זוהו כמה חשבוניות בקובץ. כל חשבונית מוצגת בנפרד עם העמודים שלה.',
    },
    validation: {
      pdfPages: 'טווח עמודי החשבונית אינו תקין. יש לסרוק את הקובץ מחדש.',
      multipleDocuments: 'הקובץ מכיל כמה חשבוניות. יש לפתוח מחדש את הסריקה ולאשר כל חשבונית בנפרד.',
    },
  },
  en: {
    invoiceScan: {
      chooseHint: 'Add photos or PDF files. When several invoices are detected in one PDF, they are shown separately for review before saving.',
      pdfPageRange: 'Pages {{from}}–{{to}} of the source file ({{count}} pages)',
      pdfSplitNotice: 'Several invoices were detected in this file. Each invoice is shown separately with its own pages.',
    },
    validation: {
      pdfPages: 'The invoice page selection is invalid. Please scan the file again.',
      multipleDocuments: 'This file contains several invoices. Please reopen the scan and review each invoice separately.',
    },
  },
};
